import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import { Cotizacion } from "app/logic/guias";
import { CotizacionView } from "app/features/general/operativa/items/guias";
import { componentToRx } from "app/logic/rx";

type Entity = models.ImportesTotalesTarifa;
interface Props {
    value: Entity | null;
}

function obtenerCotiz(importes: Entity): Cotizacion {
    return {
        flete: importes.Importes.Flete,
        descuentoFlete: importes.Importes.FleteSinDescuento - importes.Importes.Flete,
        subtotal: importes.Totales.Subtotal,
        iva: importes.Totales.Iva,
        retencionIva: importes.Totales.RetencionIva,
        total: importes.Totales.Total,
        grupos: [
            {
                titulo: "Serv. adic",
                conceptos: [
                    {
                        titulo: "EAD",
                        importe: importes.Importes.EntregaDomicilio
                    }, {
                        titulo: "RAD",
                        importe: importes.Importes.RecoleccionDomicilio
                    }, {
                        titulo: "Acuse",
                        importe: importes.Importes.Acuse
                    }, {
                        titulo: "Seguro",
                        importe: importes.Importes.Seguro
                    }, {
                        titulo: "Valor factura",
                        importe: importes.Importes.ValorFactura
                    }
                ]
            }
        ]
    }
}


class ImportesPPViewNoRx extends React.PureComponent<Props> {
    render() {
        return (
            this.props.value ?
                (
                    <kea.Panel title="Porguía">
                        <h4>
                            Total por guía:
                    <b>{kea.formatCurrency(this.props.value.Totales.Total)}</b>
                        </h4>
                        <CotizacionView value={obtenerCotiz(this.props.value)} />
                    </kea.Panel>
                ) :
                (
                    <div>
                        <em>Llene los datos para ver el precio calculado</em>
                    </div>
                )
        );
    }
}

/**Muestra los importes calculados de una guia de tarifa PP */
export const ImportesPPView = componentToRx(ImportesPPViewNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifapp/edit/importes/view.tsx